import { RefObject } from 'react';

/**
 * Returns an array with HTML Elements which could be focused from keyboard
 */
export function getFocusableElements(
  element: HTMLElement | Document | null = document
): HTMLElement[] {
  if (!element) {
    return [];
  }

  return [
    ...element.querySelectorAll(
      'a[href], button, input, textarea, select, details, object, iframe, embed, [tabindex]:not([tabindex="-1"])'
    ),
  ].filter((element) => {
    const htmlElement = element as HTMLElement;
    return (
      !htmlElement.hasAttribute('disabled') &&
      !htmlElement.getAttribute('aria-hidden') &&
      htmlElement.style.display !== 'none'
    );
  }) as HTMLElement[];
}

/**
 * Returns an index of current element in focus
 */
export function getCurrentFocusedIndex(elements: HTMLElement[]): number {
  return elements.findIndex((el) => el === document.activeElement) || 0;
}

/**
 * Returns next or prev index (depends on reverse attribute) in a range from 0 to length - 1
 * @param currentIndex current index in array
 * @param length array length
 * @param reverse direction, if true then subtract 1 from currentIndex else add 1
 * @returns next or prev index (depends on reverse attribute) in a range from 0 to length - 1
 */
export function cycleArrayIndex(currentIndex: number, length: number, reverse: boolean): number {
  const delta = reverse ? -1 : 1;
  return (currentIndex + delta + length) % length;
}

export function blurActiveElement(ref: RefObject<HTMLElement | null>): void {
  if (!ref.current) {
    return;
  }

  const activeElement =
    document.activeElement && 'blur' in document.activeElement
      ? (document.activeElement as HTMLElement)
      : null;

  if (!activeElement || ref.current.contains(activeElement)) {
    return;
  }

  activeElement?.blur();
}
